import { createI18n } from 'vue-i18n';
import en from './lang/en.json';
import uk from './lang/uk.json';

const messages = {
  en,
  uk,
};

const i18n = createI18n({
  // In legacy mode vue-i18n attaches $t to every component instance and deletes it in the unmounted hook,
  // so any this.$t called after an await in an unmounted component threw "this.$t is not a function".
  // Composition mode installs $t once on app.config.globalProperties, where it lives as long as the app does.
  legacy: false,
  globalInjection: true, // $t stays available in templates and as this.$t in the Options API
  warnHtmlMessage: false, // some messages contain markup (support links and the like)
  locale: 'uk', // Поточна мова
  fallbackLocale: 'uk', // Мова за замовчуванням
  messages,
});

export default i18n;